import { createContext, useContext } from "react";

export type Options = {
  id: string;
  isopen: boolean;
  isConfigUser: boolean;
  width: string;
}

export const ModalConfigurationContext = createContext<{ options: Options; setOptions: React.Dispatch<React.SetStateAction<Options>> } | undefined>(undefined);

export const useModalConfiguration = () => {
  const context = useContext(ModalConfigurationContext);
  if (!context) {
    throw new Error('useModalConfiguration must be used within a ModalConfigurationContext.provider');
  }
  return context;
};